import {ReactReduxModal} from '../../core-utilities/react-redux-modals';
import {ReactReduxModalHOC} from '../../core-utilities/react-redux-modals/components/ReactReduxModalHOC';
import {PeopleSelectorModal, modalOptions} from '../components/PeopleSelectorModal';
import {getPeopleSelectorModal} from '../reducers/state';
import {PEOPLE_SELECTOR_MODAL_PREFIX} from './state';
import {logger} from './logger';

// Usage note: the showModal payload requires the parentId to display

const options = {
  prefix: PEOPLE_SELECTOR_MODAL_PREFIX,
  getState: getPeopleSelectorModal,
  modalOptions,
  logger,
};

export const reactReduxModal = new ReactReduxModal(options);

const modalConfig = {
  actions: reactReduxModal.actions,
  getState: getPeopleSelectorModal,
  logger,
};

options.modalComponent = ReactReduxModalHOC(PeopleSelectorModal, modalConfig);



// WEBPACK FOOTER //
// ./src/js/personnel/redux/peopleSelectorModal.js